import types from './types';

export interface OmniKeywordEntity {
  queryId: string;
  name: string;
  canEdit: boolean;
  query: { [key: string]: string };
  ownerProfile: {
    firstName: string;
    lastName: string;
    [key: string]: any;
  };
}

export interface OmniKeywordListState {
  data: OmniKeywordEntity[];
  isFetching: boolean;
}

const omniKeywordSegmentService = (
  state: OmniKeywordListState = {
    data: [],
    isFetching: true
  },
  action: { type: string; entity: { data: any[] } }
) => {
  switch (action.type) {
    case types.START_FETCH:
      return {
        data: [],
        isFetching: true
      };

    case types.RECEIVE_OMNI_KEYWORD_LIST_DATA:
      return {
        isFetching: false,
        data: action.entity.data
      };
    default:
      return state;
  }
};

export default omniKeywordSegmentService;
